import { Field, FieldProps, useFormikContext } from 'formik';
import { KeyboardDateTimePicker } from 'formik-material-ui-pickers';
import React, { FunctionComponent } from 'react';

export const DatePickerFieldEditor: FunctionComponent<FieldProps> = ({ field, form, ...other }) => {
    const { values } = useFormikContext();

    const currentError = form.errors[field.name];

    return (
        <Field
            component={KeyboardDateTimePicker}
            clearable
            name={field.name}
            format="MM/dd/yyyy hh:mm a"
            minDate={values.startDateTime}
            helperText={currentError}
            error={Boolean(currentError)}
            onError={(error: any) => {
                // handle as a side effect
                if (error && error !== currentError) {
                    form.setFieldError(field.name, error?.toString());
                }
            }}
            onChange={(date: any) => {
                form.setFieldValue(field.name, date, true);
            }}
            {...other}
        />
    );
};
